import {API_BASE} from '../config'
import type {RawAlternative, RawAnchor} from './types'

export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message)
  }
}

// GETs must not set Content-Type: the Trustup API's CORS/preflight chokes on it,
// and we don't need it. Accept only.
async function get<T>(path: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'GET',
    headers: {Accept: 'application/json'},
  })
  if (!res.ok) throw new ApiError(res.status, `GET ${path} → ${res.status}`)
  const body = (await res.json()) as unknown
  // Responses are either bare payloads or {data: payload}.
  if (body && typeof body === 'object' && 'data' in (body as Record<string, unknown>)) {
    return (body as {data: T}).data
  }
  return body as T
}

export function fetchAlternative(id: string | number): Promise<RawAlternative> {
  return get<RawAlternative>(`/alternatives/${id}`)
}

export async function fetchAnchors(alternativeId: string | number): Promise<RawAnchor[]> {
  const anchors = await get<RawAnchor[]>(
    `/alternative-anchors?alternative_id=${alternativeId}&per_page=100`,
  )
  return Array.isArray(anchors) ? anchors : []
}
